<template>
	<div class="user-picture">
		<o-skeleton width="6em" height="6em" v-if="loading"></o-skeleton>
		<div v-else>
			<div class="box" :class="css" v-if="!hasDataUrl">
				<span>{{ initials }}</span>
			</div>
			<img :class="css" v-else v-lazy="dataUrl" />
			<!-- <img :class="css" v-else :src="dataUrl" /> -->
		</div>
	</div>
</template>
<script>
	import { ref, inject, watch, computed, onMounted } from "vue";
	export default {
		props: {
			uuid: {
				type: String,
				default: null
			},
			size: {
				type: String,
				default: "small"
			},
			type: {
				type: String,
				default: "image"
			}
		},
		setup(props, context) {
			const $http = inject("$http");

			const loading = ref(true);
			const css = ref("");
			const initials = computed(() => {
				return "N/A";
			});

			const dataUrl = computed(() => {
				//return process.env.VUE_APP_API + "api/v2/cms/image/uuid/" + props.uuid;
				return (
					process.env.VUE_APP_API + "api/v2/cms/image/" + props.type + "/" + props.uuid + "/200/200"
				);
			});

			const hasDataUrl = computed(() => {
				const val = props.uuid;
				return val != null;
			});

			css.value = [props.size].join(" ");

			onMounted(() => {
				loading.value = false;
			});

			return {
				loading,
				dataUrl,
				hasDataUrl,
				css,
				initials
			};
		}
	};
</script>
<style lang="scss" scoped>
	.item-image {
		& img {
			border-radius: 4px;

			&.small {
				width: 6em;
			}

			&.medium {
				width: 7em;
			}

			&.large {
				width: 8em;
			}
		}

		& .box {
			text-align: center;
			border-radius: 4px;
			border: 1px solid #3e3e3e;

			&.small {
				width: 6em;
				height: 6em;
			}
			&.medium {
				width: 7em;
				height: 7em;
			}
			&.large {
				width: 8em;
				height: 8em;
			}

			& span {
				font-size: 2em;
			}
		}
	}
</style>